import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RootAction, State } from 'store/state';
import {
  activePromotionPlansDataSelector,
  isPrivateBulletinSelectPromotionPlanModalSelector,
  privateBulletinSelectPromotionPlanModalBulletinIdSelector,
  isTranzilaHostedFieldsModeSelector,
} from 'store/state/app/private-user-monetization/selectors';
import { setHostedFieldsModalAction, setPrivateBulletinSelectPromotionPlanModal } from 'store/state/app/actions';
import { PromotionPlanInfo } from 'store/sagas/apiService/types';
import { PrivateBulletinSelectPromotionPlanModalBase } from './PrivateBulletinSelectPromotionPlanModal';
import { privateUserIdSelector } from 'store/state/domainData/selectors';
import { PAYMENT_PROCESS_ID } from 'consts/localStorageKeys';
import { newListingResponseSelector } from 'store/state/mutationsResponse/selectors';
import { handlePromotionPlanSelect } from '../shared/handlePromotionPlanSelect';
import { INITIATE_SOURCE } from 'components/private-bulletin-promotion/types';
import { TranzilaModalType } from 'components/tranzila-hosted-fields/types';
import withEvents from 'analytics/withEvents';
import { ISelectPromotionPlanModalProps } from './types';
import { find } from 'lodash';
import { privateUserMonetizationEventsSourceSelector } from 'store/state/app/selectors';
import { makeVariantToEventsString } from 'store/sagas/analytics/utils';

const mapStateToProps = (state: State) => ({
  isOpen: isPrivateBulletinSelectPromotionPlanModalSelector(state),
  plans: activePromotionPlansDataSelector(state),
  userId: privateUserIdSelector(state),
  listingUploaded: newListingResponseSelector(state),
  bulletinId: privateBulletinSelectPromotionPlanModalBulletinIdSelector(state),
  isHostedFieldsMode: isTranzilaHostedFieldsModeSelector(state),
  eventSource: privateUserMonetizationEventsSourceSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onClose: () => dispatch(setPrivateBulletinSelectPromotionPlanModal({ isOpen: false, bulletinId: null })),
  onPlanSelect: (plan: PromotionPlanInfo, userId: string, bulletinId: string | null) => {
    const key = bulletinId ? `${PAYMENT_PROCESS_ID}_${userId}_${bulletinId}` : userId;
    const isSelectedPaidPlan = plan.price > 0 || Boolean(plan.isUserEligibleForGrant);
    const closeModal = () => dispatch(setPrivateBulletinSelectPromotionPlanModal({ isOpen: false, isSelectedPaidPlan, bulletinId: null }));
    handlePromotionPlanSelect(dispatch, plan, key, INITIATE_SOURCE.REGULAR, closeModal, bulletinId);
  },
  onHostedFieldsPlanSelect: (plan: PromotionPlanInfo, bulletinId: string | null) => {
    dispatch(setHostedFieldsModalAction({
      planInfo: plan,
      modalType: TranzilaModalType.Loading,
      paymentDealType: 'promotion_plan_regular',
      ...(bulletinId ? { bulletinId } : {}),
    }));
  },
});

const PrivateBulletinSelectPromotionPlanModalBaseWithEvents = withEvents<ISelectPromotionPlanModalProps>((sendEvent, props) => ({
  onHostedFieldsPlanSelect(plan: PromotionPlanInfo) {
    const planById = props.plans && props.plans.length ? find(props.plans, { id: plan.id }) : undefined;
    sendEvent('user_promotion_plan_select', 'user', {
      event: {
        deal_type: 'promotion_plan_regular',
        source: props.eventSource,
        promotion_plan: planById ? makeVariantToEventsString(planById.variant) : undefined,
      },
    });
  },
}))(PrivateBulletinSelectPromotionPlanModalBase);

export const PrivateBulletinSelectPromotionPlanModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateBulletinSelectPromotionPlanModalBaseWithEvents);

export default PrivateBulletinSelectPromotionPlanModal;
